export default "__VITE_ASSET__CS8iS5k5__"